import { CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import { ContainerSectionMissionImage } from './style';
import { ContainerImg, ContainerImgText } from '../../../main/style';
import Regi1 from '../../../../../assets/img/register1.png';
import Regi2 from '../../../../../assets/svg/figure-mission.svg';
import founder1 from '../../../../../assets/img/april.png';
import founder2 from '../../../../../assets/img/Aaron.png';
import start from '../../../../../assets/img/start.png';
import ceo from '../../../../../assets/img/ceo.png';
import new1 from '../../../../../assets/img/new1.png';
import new4 from '../../../../../assets/img/new4.png';
import new2 from '../../../../../assets/img/new2.png';
import new3 from '../../../../../assets/img/new3.png';
import new5 from '../../../../../assets/img/new5.png';
import new6 from '../../../../../assets/img/new6.png';
import log from '../../../../../assets/svg/fayven-about.svg';
import './style.css';
import { MediaCard } from '../../../../../components';

export default function SectionOneAbout() {
  const news = [
    {
      id: 1,
      img: new1,
      title: 'Catalyst',
      text: 'Tampa startup wins $50k in cash and prizes from pitch competition',
      page: 'https://stpetecatalyst.com/tampa-startup-wins-50k-in-cash-and-prizes-from-pitch-competition/',
    },
    {
      id: 5,
      img: new4,
      title: 'Military.com',
      text: 'How a Vet-Owned Business Is Helping Other Small Businesses',
      page: 'https://www.military.com/veteran-jobs/how-vet-owned-business-helping-other-small-businesses-flourish.html',
    },
    {
      id: 3,
      img: new2,
      title: 'Hypepotamus',
      text: 'Meet the founder playing matchmaker to vendors and ...',
      page: 'https://hypepotamus.com/feature/fayven-tampa/',
    },
    {
      id: 4,
      img: new3,
      title: 'Catalyst',
      text: 'St. Pete Pitch Night shines a light on local female entrepreneurs',
      page: 'https://stpetecatalyst.com/st-pete-pitch-night-shines-a-light-on-local-female-entrepreneurs/',
    },

    {
      id: 6,
      img: new5,
      title: 'Medium',
      text: 'Women in Tech Tampa Bay: April Caldwell, CEO of fayVen',
      page: 'https://medium.com/embarc-collective/women-in-tech-tampa-bay-april-caldwell-ceo-of-fayven-57b700cb2b30 ',
    },
    {
      id: 2,
      img: new1,
      title: 'Voyage Tampa',
      text: 'Community Highlights: Meet April Caldwell of fayVen',
      page: 'http://voyagetampa.com/interview/community-highlights-meet-april-caldwell-of-fayven/',
    },
    {
      id: 7,
      img: new6,
      title: 'The Business Journals',
      text: 'Tampa startup wins $50K prize on Bloomberg pitch TV show',
      page: 'https://www.bizjournals.com/tampabay/inno/stories/profiles/2022/03/29/tampa-startup-fayven-wins-on-bloomberg-pitch-show.html?taid=6242f4cf1a9e390001f0e7b5&utm_campaign=trueanthem&utm_medium=trueanthem&utm_source=twitter',
    },
  ];

  return (
    <Grid container>
      <Grid container className="card-one">
        <ContainerSectionMissionImage>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={1.5} />
              <Grid item xs={4}>
                <ContainerImgText className="image" src={start} />
              </Grid>
              <Grid item xs={0.5} />
              <Grid item xs={0.5} />
              <Grid item xs={4}>
                <ContainerImg className="image" src={ceo} />
              </Grid>
              <Grid item xs={1.5} />
            </Grid>
          </Grid>
        </ContainerSectionMissionImage>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={1.5} />
            <Grid item xs={4}>
              <ContainerImgText className="image" src={Regi1} />
            </Grid>
            <Grid item xs={0.5} />
            <Grid item xs={0.5} />
            <Grid item xs={4}>
              <ContainerImg className="image" src={Regi2} />
            </Grid>
            <Grid item xs={1.5} />
          </Grid>
        </Grid>
      </Grid>
      <div className="abt-title">MEET OUR FOUNDERS</div>
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={1.5} />
            <Grid item xs={4}>
              <ContainerImg className="image" src={founder1} />
            </Grid>
            <Grid item xs={0.5} />
            <Grid item xs={0.5} />
            <Grid item xs={4}>
              <ContainerImg className="image" src={founder2} />
            </Grid>
            <Grid item xs={1.5} />
          </Grid>
        </Grid>
      </Grid>
      <div className="abt-subtitle">OUR NAME</div>
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={0.5} />
            <Grid item xs={11}>
              <ContainerImg className="image" src={log} />
            </Grid>
            <Grid item xs={0.5} />
          </Grid>
        </Grid>
      </Grid>
      <div className="abt-title">NEWS</div>

      <ContainerSectionMissionImage>
        <Grid container spacing={2} sx={{ px: 12 }}>
          {news.map((newItem) => (
            <Grid key={newItem.id} item xs={3} sx={{ pb: 3 }}>
              <MediaCard
                image={newItem.img}
                cardWidth={250}
                cardHeight={250}
                redirectPage={newItem.page}>
                <CardContent>
                  <Typography variant="h6" color="text.secondary">
                    {newItem.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {newItem.text}
                  </Typography>
                </CardContent>
              </MediaCard>
            </Grid>
          ))}
        </Grid>
      </ContainerSectionMissionImage>
    </Grid>
  );
}
